var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.286,
    height: 25.286,
    viewBox: "0 0 25.286 25.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6a709f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.016,411.426a7.323,7.323,0,0,1-1.847-4.863l-4.474,1.9A2.782,2.782,0,0,0,0,411.029v.74H8.376q-.187-.163-.361-.344Zm0,0",
    transform: "translate(0 -386.483)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M349.076,408.466l-4.474-1.9a7.32,7.32,0,0,1-1.847,4.863q-.173.181-.361.344h8.376v-.741A2.782,2.782,0,0,0,349.076,408.466Zm0,0",
    transform: "translate(-325.485 -386.484)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M164.892,384.25a7.35,7.35,0,0,1-9.983,0v.949a5.959,5.959,0,0,0,1.432,3.99,5.308,5.308,0,0,0,7.118,0,5.958,5.958,0,0,0,1.432-3.99Zm0,0",
    transform: "translate(-147.257 -365.273)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M61.669,155.476v-5.289a7.869,7.869,0,0,1,.15-1.535h-.644a2.225,2.225,0,0,0-2.222,2.222v3.186a2.225,2.225,0,0,0,2.222,2.223h.541a6.939,6.939,0,0,1-.047-.807Zm0,0",
    transform: "translate(-56.041 -141.311)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M395.281,148.652h-.663a7.885,7.885,0,0,1,.169,1.636v5.188a6.937,6.937,0,0,1-.047.806h.541a2.225,2.225,0,0,0,2.222-2.222v-3.186a2.225,2.225,0,0,0-2.222-2.222Zm0,0",
    transform: "translate(-375.128 -141.311)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M108.273,0c-4.42,0-7.041,2.018-7.675,5.864.055,0,.11,0,.166,0h1.1A4.626,4.626,0,0,1,103.075,4.1a3.161,3.161,0,0,1,2.115-.777,6.326,6.326,0,0,1,2.28.553,5.039,5.039,0,0,0,.8.269,4.843,4.843,0,0,0,.779-.267,6.1,6.1,0,0,1,2.247-.554,3.714,3.714,0,0,1,3.342,2.533h1.141c.056,0,.111,0,.166,0C115.314,2.018,112.693,0,108.273,0Zm0,0",
    transform: "translate(-95.63 0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M153.692,108.553a4.184,4.184,0,0,1-2.329.705h-1.136a.741.741,0,1,1,0-1.482h1.136a2.708,2.708,0,0,0,1.507-.456l2.15-1.434v-4.363a6.232,6.232,0,0,0-.5-2.469c-1.388-3.219-3.633-.879-5.035-.879-1.445,0-3.9-2.486-5.192,1.189a6.221,6.221,0,0,0-.342,2.058v5.289a5.566,5.566,0,0,0,10.97,1.021Zm0,0",
    transform: "translate(-136.844 -92.546)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgents);
export default __webpack_public_path__ + "static/media/agents.2c8dc85a94b6f5b0acbf2b717940d53d.svg";
export { ForwardRef as ReactComponent };